import React from "react";
import PropTypes from "prop-types";
import { StyledHeader, StyledBrand, StyledImageBrand, StyledNavbar } from "./Header.styles";
import iconProfile from "../../../assets/img/icon-profile.png";
import iconCoupon from "../../../assets/img/icon-coupon.png";
import iconClose from "../../../assets/img/icon-close.png";
import iconWarning from "../../../assets/img/icon-warning.png";
import { useHistory } from "react-router-dom";

import useControllers from "../../../controllers";
import useModels from "../../../models";
import useViews from "../..";
/*import { StyledSectionHome } from "../../screens/user/home/UserHome.styles"*/
/**
 * Header component
 */
export const Header = (props) => {
  const { useComponents } = useViews();
  const { Button, ButtonNav, Typography, CardNavbar, Modal } = useComponents();

  const { useScreensHooks, useComponentsHooks } = useControllers();
  const { useHeader } = useComponentsHooks();
  const { useUser } = useScreensHooks();
  const { useMenu } = useUser();
  const { useGenerateCoupon } = useMenu();

  const { useSelectors } = useModels();
  const { useSelector, useCouponSelectors, useUserSelectors, useUtmSelectors } = useSelectors();
  const { couponListSelector } = useCouponSelectors();
  const { profileSelector } = useUserSelectors();
  const { utmSelector } = useUtmSelectors();

  const history = useHistory();
  const { backgroundColor, colorContrast, imageBrand } = props;
  const {
    redirectProfile,
    redirectHome,
    showButtonMenu,
    showDefaultTextHeaderForm,
    onLogOut,
  } = useHeader();
  const userInfo = useSelector(profileSelector);
  const coupons = useSelector(couponListSelector);
  const { value: UTM } = useSelector(utmSelector);

  const { submit, limitModal, toggleLimitModal, modalText, date, sso } = useGenerateCoupon();

  const openNav = () => {
    if (document.getElementById("sideNavigation").style.height === "100%") {
      document.getElementById("sideNavigation").style.height = "0%";
    } else {
      document.getElementById("sideNavigation").style.height = "100%";
    }
  };
  return (
    <StyledHeader
      backgroundColor={backgroundColor}
      colorContrast={colorContrast}
      className="bg-gray-700 text-center py-3 relative z-10"
    >
      <StyledBrand
        backgroundColor={backgroundColor}
        colorContrast={colorContrast}
        className="d-table mx-auto p-1 text-xs text-white font-black uppercase flex relative"
      >
        {showButtonMenu() ? (
          <ButtonNav
            alt="Menu"
            onClick={(e) => openNav()}
            className="absolute top-0"
            color="#000"
          />
        ) : null}

        {showDefaultTextHeaderForm() ? (
          <Typography
            variant="p"
            className="sc-bqyKva GIGsP text-white mx-auto justify-center flex items-center font-customBold w-9/12"
          >
            Regístrate para acceder a la promo
          </Typography>
        ) : (
          <StyledImageBrand src={imageBrand} />
        )}
      </StyledBrand>
      <StyledNavbar id="sideNavigation">
        <div className="w-11/12 mx-auto my-2 border-b-2 py-2 items-center">
          <Button
            label="generar nuevo cupón"
            icon="qr"
            primary
            className="mx-auto border-none rounded-md"
            onClick={() => {
              submit();
              openNav();
            }}
          />
          <Typography
            variant="span"
            className="text-black mx-auto justify-center flex items-center my-2"
          >
            <img src={iconWarning} alt="warning" className="h-3 mx-2" />
            Recuerda que puedes redimir un cupón cada 48 horas
          </Typography>
        </div>
        <CardNavbar
          title={`${userInfo.name} ${userInfo.last_name}`}
          subtitle="Ver mi perfil"
          icon={iconProfile}
          onClick={(e) => {
            redirectProfile();
            openNav();
          }}
        />
        <CardNavbar
          title="Mis cupones"
          subtitle="Ver todos mis cupones"
          contentExtra={`${coupons.pending.length > 0 ? `${coupons.pending.length} nuevos` : ""} `}
          icon={iconCoupon}
          onClick={(e) => {
            redirectHome();
            openNav();
          }}
        />
        <CardNavbar
          title="Cerrar sesión"
          icon={iconClose}
          onClick={() => {
            openNav();
            onLogOut(sso);
          }}
        />
      </StyledNavbar>
      <Modal
        show={limitModal}
        icon={iconWarning}
        text={modalText}
        date={date}
        onclick={() => {
          toggleLimitModal();
          history.push(`/user/home${UTM && "?" + UTM}`);
          openNav();
        }}
      />
    </StyledHeader>
  );
};

Header.propTypes = {
  /**
   * What background color to use
   */
  backgroundColor: PropTypes.string,
  /**
   * What contrast color to use
   */
  colorContrast: PropTypes.string,
  /**
   * Header contents
   */
  label: PropTypes.string.isRequired,
};

Header.defaultProps = {
  backgroundColor: null,
  colorContrast: null,
  label: "Marca",
};

export default Header;
